import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getCurrentQuarters, lockEditingStatus } from "../../../server/server";
import { Button } from "@mui/material";

const ReportingQuarterSelect = () => {
  const location = useLocation();
  const type = location.pathname.includes("national");
  const [availableQuarters, setAvailableQuarters] = React.useState<any[]>([]);
  const navigate = useNavigate();
  const [reportLocked, setReportLocked] = React.useState(false);

  const fetchCurrentStatusData = async () => {
    const response = await lockEditingStatus();

    if (response.status === 200) setReportLocked(response.data.isActive);
  };

  const getAvailableQuarters = async () => {
    const resp = await getCurrentQuarters(
      type ? "regulation" : "measure",
      0,
      0
    );

    if (resp.status === 200) {
      setAvailableQuarters(resp.data[0]);
    } else {
      setAvailableQuarters([]);
    }
  };

  useEffect(() => {
    getAvailableQuarters();
    fetchCurrentStatusData();
  }, [type]);

  return (
    <div className="py-10 px-6 overflow-auto gray-small-scroll h-full flex flex-col">
      <div className="flex gap-6  flex-col">
        <h1 className="text-[#04438b] text-4xl font-bold">
          Одаберите квартал за извештавање {type ? "прописа" : "мера"}
        </h1>
        <p className="italic">
          *Зеленом бојом је обележен квартал који је доступан за измене, остали
          могу само бити прегледани.
        </p>
      </div>
      <div className="mt-6 flex flex-row gap-4">
        {availableQuarters.map((q) => {
          return (
            <div className="flex items-center">
              <Button
                variant="contained"
                sx={{
                  backgroundColor:
                    !reportLocked && q.status ? "#28a745" : "#0F2765",
                }}
                // endIcon={<FaSave />}
                onClick={() => {
                  navigate(
                    "/reporting/" +
                      (type ? "national" : "measures") +
                      "/" +
                      q.id
                  );
                }}
              >
                {q.quarter}
              </Button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ReportingQuarterSelect;
